import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

import { MediaObserver } from '@angular/flex-layout';
import { $e } from 'codelyzer/angular/styles/chars';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NUMBER_12, NUMBER_24 } from '~shared/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { TooltipPositions } from '../models/tooltip-positions.model';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnDestroy {
  @Input() position: TooltipPositions;
  @Input() width = NUMBER_24;
  @Input() height = NUMBER_24;
  @Input() fontSize = NUMBER_12;
  @Input() withBorders = false;
  @Input() newOverlay = false;
  @Input() tooltipTextColor = '#002866'; // blue-shade-60
  @Input() tooltipBackgroundColor = '#cce0ff'; // blue-tint-80
  @Input() bulletTextColor = '#002866'; // blue-shade-60
  @Input() bulletBackgroundColor = '#cce0ff'; // blue-tint-80
  @Input() bulletIconName: string;
  @Input() tabIndex?: string;
  @Output() onTooltipShow: EventEmitter<boolean> = new EventEmitter();
  isVisible = false;
  isMobileDevice = false;
  positions = TooltipPositions;
  @Input() ariaLabelContent = 'Tooltip content';

  private destroySubject$ = new Subject<boolean>();

  constructor(private elementRef: ElementRef, private mediaObserver: MediaObserver) {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(() => {
        this.isMobileDevice =
          this.mediaObserver.isActive(MEDIA_ALISES.mobile) || this.mediaObserver.isActive(MEDIA_ALISES.tablet);
      });
  }

  @HostListener('window:click', ['$event.target'])
  private onGlobalClick(targetElement): void {
    const isOutsideClick = !this.elementRef.nativeElement.contains(targetElement);

    if (this.isMobileDevice && this.isVisible && isOutsideClick) {
      this.isVisible = false;
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  toggleTooltip(event, nextState?: boolean) {
    event?.stopPropagation();
    if (typeof nextState !== 'boolean') {
      this.isVisible = !this.isVisible;
    } else if (this.isVisible !== nextState) {
      this.isVisible = nextState;
    }
    this.onTooltipShow.emit(this.isVisible);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && (event.target as HTMLElement)?.classList?.contains?.('tooltip')) {
      event?.preventDefault();
      event?.stopPropagation();
    }
  }

  protected readonly $e = $e;
}
